import script from "./PgsInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./PgsInfo.vue?vue&type=script&setup=true&lang=ts"

import "./PgsInfo.vue?vue&type=style&index=0&id=5586e206&lang=scss"

const __exports__ = script;

export default __exports__